<template lang="pug">
	.easy-creative--templates.flex-col.space-large
		.flex-row.justify
			.flex-row.align-center.space
				.font-big.upper.grey {{$tCaption('Templates')}}
			.flex-row.align-center.space
				Dropdown.small(:getData="loadCategories", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :columns="[{ dataField: 'Name', caption: $tCaption('Category') }]",
					displayExpr="Name",
					valueExpr="Oid",
					:placeholder="$tCaption('Category')",
					:showColumnHeaders="false",
					:filtersVisible="false",
					:selectedItems="filteredCategories.map(f => f.Oid)",
					:searchVisible="false",
					:multiple="true",
					:width="150",
					stylingMode="filled",
					@select-data="v => filteredCategories = v || []")
				Dropdown.small(:getData="(a,b,c) => $Data.getUsedLanguages(a,b,c,true)", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :columns="[{ dataField: 'Name', caption: $tCaption('Language') }]",
					displayExpr="Name",
					valueExpr="Code",
					:placeholder="$tCaption('Language')",
					:showColumnHeaders="false",
					:filtersVisible="false",
					:selectedItems="filteredLanguages.map(f => f.Code)",
					:searchVisible="true",
					:multiple="true",
					:width="160",
					stylingMode="filled",
					@select-data="v => filteredLanguages = v || []")
		.flex-row.wrap
			.template-item.flex-col.flex-1.tile.center(v-for="template in templates", :style="{ '--bg': template.ImageUrl && `url('${template.ImageUrl}')` || '#f4f4f4' }", 
				:class="{ 'has-image': template.ImageUrl, 'active': activeTemplate === template }", @click="setActiveTemplate(template)")
				.image
				.actions.flex-row.center.space-large
					.action-button.clickable.flex-row.align-center.center(v-if="template.FinalAudioUrl", @click="playAudio(template)", :title="$tCaption('Play', '@actions')")
						fas(:icon="template.Oid === isAudioLoading ? 'spinner' : (isPlaying === template.Oid ? 'stop' : 'play')", :spin="template.Oid === isAudioLoading")
					.action-button.clickable.flex-row.align-center.center(v-if="template.IsOwn", :title="$tCaption('Select', '@actions')", @click.stop="selectTemplate(template)")
						fas(icon="check")
					.action-button.clickable.flex-row.align-center.center.space.font-small(v-if="!template.IsOwn", :title="$tCaption('Buy', '@actions')", @click.stop="buyTemplate(template)")
						fas(:icon="buyingTemplateId === template.Oid ? 'spinner' : 'cart-shopping'", :spin="buyingTemplateId === template.Oid")
						.price {{template.Price ? `${template.Price} ${template.CurrencyCode}` : $tCaption('Free') }}
				.header.flex-row.center
					.text.nowrap {{template.RootCreativeName || template.Name}}
		.flex-row.full-width.align-center.center
			Loader(v-if="isLoadingTemplates", :text="$tCaption('Loading templates') + '..'")
		.flex-row.justify
			.left
			DxButton(v-if="!isLoadingTemplates && canLoadMore",:text="$tCaption('Load more')", @click="() => loadTemplates()", stylingMode="text", :disabled="!!isLoadingTemplates")
			.right
		.flex-row.space.align-center
			DxButton(:text="$tCaption('Back', '@actions')", @click="$emit('back')")
		Popup(v-if="templatePopupVisible && activeTemplate", :popupVisible.sync="templatePopupVisible", :title="activeTemplate.RootCreativeName || activeTemplate.Name", :width="640", :height="420")
			.easy-creative--templates--template-popup
				.flex-col.space-medium.template-popup
					.flex-row.space-large
						.image(v-if="activeTemplate.ImageUrl", :style="{ '--img': `url('${activeTemplate.ImageUrl}')` }")
						.flex-col.flex-3
							.font-tiny.upper.grey {{$tCaption('Language')}}
							.font-big {{activeTemplateLanguageName}}
						.flex-col.flex-1
							.font-tiny.upper.grey {{$tCaption('Price')}}
							.font-big {{activeTemplate.Price || this.$tCaption('Free')}}
						.flex-col.flex-1(v-if="activeTemplate.Duration")
							.font-tiny.upper.grey {{$tCaption('Duration')}}
							.font-big {{$Data.secondsToDisplayValue(activeTemplate.Duration / 1000)}}
					.flex-row.space-large
						.flex-col.space(v-if="activeTemplate.Description")
							.font-tiny.upper.grey {{$tCaption('Description')}}
							.font-big {{activeTemplate.Description}}
			template(slot="actions-left")
				DxButton(v-if="activeTemplate.FinalAudioUrl", @click="playAudio(activeTemplate)", :text="isPlaying === activeTemplate.Oid ? $tCaption('Stop', '@actions') : $tCaption('Play', '@actions')", :icon="isPlaying === activeTemplate.Oid ? 'square' : 'fas fa-play'",
					:disabled="activeTemplate.Oid === isAudioLoading")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="templatePopupVisible = false")
				DxButton(:text="$tCaption('Select', '@actions')", v-if="activeTemplate.IsOwn", type="success", icon="fas fa-check", @click="templatePopupVisible = false; selectTemplate(activeTemplate)")
				DxButton(:text="activeTemplate.Price ? $tCaption('Buy', '@actions') : $tCaption('Free')", v-if="!activeTemplate.IsOwn", type="default", icon="fas fa-cart-shopping", @click="templatePopupVisible = false; buyTemplate(activeTemplate)")
</template>

<script>
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';
	import Loader from 'app-core/Loader.vue';
	import Popup from 'app-core/Popup.vue';
	import cognitiveArrays from 'view/insertion/cognitive-arrays';
	import Dropdown from 'app-core/Dropdown.vue';

	export default {
		translationCategory: 'creative.EasyCreative',
		name: 'easy-creative-templates',
		props: ['info'],
		mixins: [cognitiveArrays],
		components: {
			DxButton, Loader, Popup, Dropdown
		},
		data() {
			return {
				templates: [],
				noMoreTemplates: false,
				myTemplatesCounter: 0,
				myTemplatesTotal: 0,
				myTemplatesIsFullyLoaded: false,
				storeTemplatesCounter: 0,
				storeTemplatesTotal: 0,
				storeTemplatesFullyLoaded: false,
				loadCount: 9,
				isLoadingTemplates: false,
				activeTemplate: null,
				isPlaying: null,
				isAudioLoading: false,
				buyingTemplateId: null,
				selectedTemplate: null,
				templatePopupVisible: false,
				filteredCategories: [],
				filteredLanguages: [],
				categoriesLoaded: false,
				categoriesLoading: false
			};
		},
		computed: {
			canLoadMore() {
				return !this.myTemplatesIsFullyLoaded || !this.storeTemplatesFullyLoaded;
			},
			activeTemplateLanguageName() {
				return this.activeTemplate?.LanguageCode && this.languages.find(f => f.locale === this.activeTemplate?.LanguageCode)?.text;
			}
		},
		watch: {
			filteredLanguages() {
				this.$reloadTemplatesStore();
			},
			filteredCategories() {
				if (!this.categoriesLoaded) return;
				this.$reloadTemplatesStore();
			}
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeTemplates = this;
			this.$reloadTemplatesStore = _.debounce(() => this.loadTemplates(true), 1000, {
				leading: false,
				trailing: true,
				maxWait: 2000
			});
		},
		destroyed() {
			delete this.$reloadTemplatesStore;
		},
		methods: {
			loadCategories(page, skip, opts) {
				if (this.categoriesLoading || this.categoriesLoaded) {
					return this.$Data.getTemplateCategories(page, skip, opts);
				}
				this.isLoadingTemplates++;
				this.categoriesLoading = true;
				return this.$Data.getTemplateCategories(page, skip, opts).then(r => {					
					if (r?.Results?.length) {
						const adsCategory = r?.Results?.find(f => `${f.Name}`.toLowerCase() === 'ads');
						if (adsCategory) {
							this.filteredCategories = [adsCategory];
						}
					}
					setImmediate(() => {
						this.categoriesLoaded = true;
						this.loadTemplates()
					});
					return r;
				}).finally(() => {
					this.categoriesLoaded = true;
					this.isLoadingTemplates--;
				});
			},
			setActiveTemplate(template) {
				this.activeTemplate = template;
				this.showTemplatePopup();
			},
			selectTemplate(v) {
				this.selectedTemplate = v;
				this.$emit('next');
			},
			showTemplatePopup() {
				this.templatePopupVisible = false;
				setImmediate(() => this.templatePopupVisible = true);
			},
			async loadTemplates(clear) {
				if (!this.categoriesLoaded) return;
				try {
					if (clear) {
						this.storeTemplatesFullyLoaded = false;
						this.myTemplatesIsFullyLoaded = false;
						this.templates = [];
						this.myTemplatesCounter = 0;
						this.storeTemplatesCounter = 0;
					}
					this.isLoadingTemplates++;
					if (this.myTemplatesIsFullyLoaded) {
						if (!this.storeTemplatesFullyLoaded) {
							var storeTemplates = await this.getTemplates(false, this.getPage(this.storeTemplatesCounter));
							this.storeTemplatesTotal = storeTemplates.TotalNumberOfRecords;
							if (storeTemplates.Results.length) {
								this.storeTemplatesCounter += storeTemplates.Results.length;
								this.templates.push(...storeTemplates.Results);
							}
							if (this.storeTemplatesCounter >= this.storeTemplatesTotal) {
								this.storeTemplatesFullyLoaded = true;
							}
						}
					} else {
						var myTemplates = await this.getTemplates(true, this.getPage(this.myTemplatesCounter));
						this.myTemplatesTotal = myTemplates.TotalNumberOfRecords;
						if (myTemplates.Results.length) {
							this.myTemplatesCounter += myTemplates.Results.length;
							myTemplates.Results.map(f => f.IsOwn = true);
							this.templates.push(...myTemplates.Results);
						}

						if (this.myTemplatesCounter >= this.myTemplatesTotal) {
							this.myTemplatesIsFullyLoaded = true;
							
							if (!this.storeTemplatesCounter || this.storeTemplatesCounter >= this.storeTemplatesTotal) {
								this.loadTemplates();
							}
						}
					}
				} finally {
					this.isLoadingTemplates--;
				}
			},
			getTemplates(own, page) {
				const filters =  [];

				if (this.filteredLanguages.length) {
					const filteredLanguagesFilter = [];
					this.filteredLanguages.map((f, i) => {
						if (i > 0) {
							filteredLanguagesFilter.push('or');
						}
						filteredLanguagesFilter.push(['LanguageCode', '=', f.Code]);
					});
					if (filters.length) filters.push('and');
					filters.push(filteredLanguagesFilter);
				}

				if (this.filteredCategories.length) {
					const filteredCategoriesFilter = [];
					this.filteredCategories.map((f, i) => {
						if (i > 0) {
							filteredCategoriesFilter.push('or');
						}
						filteredCategoriesFilter.push(['TemplateCategory.Oid', '=', f.Oid]);
					});
					if (filters.length) filters.push('and');
					filters.push(filteredCategoriesFilter);
				}
				
				const filterCriteria = filters.length ? `&filterCriteria=${encodeURIComponent(JSON.stringify(filters))}` : '';
				return this.$Data.getExternalApi('Creative/GetCreativeTemplates', `selectOnlyMyTemplates=${own}&page=${page + 1}${filterCriteria}`, this.loadCount);
			},
			getPage(count) {
				return (count / this.loadCount);
			},
			randomGradient() {
				var randomColor1 = "#" + Math.floor(Math.random()*16777215).toString(16),
					randomColor2 = "#" + Math.floor(Math.random()*16777215).toString(16);
				return 'radial-gradient(at top left, '+randomColor1+', '+randomColor2+')'
			},
			playAudio(template) {
				if (this.isAudioLoading) return;

				let hasBeenPlaying = this.isPlaying === template.Oid;
				this.stopAudio();

				if (hasBeenPlaying) return;

				this.player = new Audio();
				try {
					this.player.src = `${template.FinalAudioUrl}`;
					this.player.play();
					this.isPlaying = template.Oid;
					this.isAudioLoading = template.Oid;
					this.player.addEventListener('canplaythrough', () => this.isAudioLoading = false, false);
					this.player.addEventListener('ended', () => this.isPlaying = null, false);
				} catch {
					this.isAudioLoading = null;
					this.isPlaying = null;
				}
			},
			stopAudio() {
				if (this.player) {
					this.player.pause();
				}
				this.isPlaying = null;
			},
			buyTemplate(template) {
				const finish = () => {
					this.buyingTemplateId = null;
				}
				const proceedText = template.Price > 0 ? 
					this.$tCaption('The item "<NAME>" will be added to your account. Would you like to proceed to checkout?') :
					this.$tCaption('The item "<NAME>" will be added to your account. Would you like to continue?');
				this.$confirmMessage({
					title: this.$tCaption('Confirm action', '@actions'),
					text: proceedText.replace('<NAME>', template.RootCreativeName),
					handler: () => {
						this.buyingTemplateId = template.Oid;
						this.$Data.postExternalApi(
								'CustomerInvoice/CreateInvoice',
								[{
									ProductId: template.Oid,
									Type: this.$Data.objectTypes.CreativeTemplate
								}])
							.then(({Data}) => {
								const isPurchasesActivated = Data?.IsPurchasesActivated != null ? Data?.IsPurchasesActivated : [1,2,3].indexOf(Data.ProductsActivationStatus) > -1;
								if (Data.ProductsActivationStatus === 4) {
									this.$notifyError(this.$tCaption('Some error has been occured while processing.'));
									return;
								}
								if (isPurchasesActivated) {
									this.$set(template, 'IsOwn', true);
									const mustBePaid = template.Price > 0 ? this.$tCaption('The invoice #"<InvoiceNumber>" must be paid within "<PaymentDays>" days.') : '';
									this.selectTemplate(template);
									this.$notifySuccess(
										(this.$tCaption(`The "<TemplateName>" template has been successfully added to your account. `) + mustBePaid)
											.replace('<TemplateName>', template.RootCreativeName)
											.replace('<InvoiceNumber>', Data.InvoiceNumber)
											.replace('<PaymentDays>', Data.PaymentDays));
									finish();
								} else {
									this.$notifySuccess(this.$tCaption('An invoice has been created. The purchased template will be available after payment of the invoice.'));
									if (this.$auth.hasAccessToCompanyProfile()) {
										this.$router.push({ name: 'company-profile', params: { activeTab: 'invoices' } });
									} else {
										finish();
									}
								}
							});
					},
					cancel: finish
				});
			},
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.easy-creative--templates {
		min-height: 300px;

		@media all and (min-width: 720px) {
			width: 720px;
		}

		.template-item {
			padding: 0px !important;
			margin: 2px;
			background: #dedede;
			border-radius: 4px;
			flex-basis: 200px;
			min-height: 150px;
			width: auto !important;
			height: auto !important;
			font-size: 16px !important;
			position: relative;
			overflow: hidden;
			transition: 0.3s;

			.header {
				background: rgba(255,255,255,0.8);
				padding: 10px 5px;
				z-index: 1;
				transition: 0.75s;
				margin-bottom: 0px;

				.text {
					max-width: 360px;
					overflow: hidden;
					text-overflow: ellipsis;
					text-align: start;
				}
			}

			&.has-image {
				.image {
					position: absolute;
					left: 0px;
					top: 0px;
					width: 100%;
					height: 100%;
					border-radius: 4px;
					background: var(--bg);
					background-size: cover;
					filter: blur(1px);
					transition: 0.75s;
					background-size: 130%;
					background-position: center;
				}
			}

			&:not(.has-image) {
				background: var(--bg);
			}

			.actions {
				position: absolute;
				top: 25px;
				width: 100%;
				opacity: 0;
				pointer-events: none;
				transition: 0.75s;

				.action-button {
					padding: 10px;
					border-radius: 100px;
					background: rgba(255,255,255,0.9);
					min-width: 40px;
					min-height: 40px;
					border: 2px solid rgba(0,0,0,0.05);

					&:hover {
						background: $base-accent;
						color: $base-bg;
					}
				}
			}

			&:hover, &.active {
				.image {
					filter: blur(0px);
					background-size: 110%;
				}

				.header {
					background: $base-accent;
					color: $base-bg;
					margin-top: 80px;
				}
				
				.actions {
					opacity: 1;
					pointer-events: all;
				}
			}
		}
	}

	.easy-creative--templates--template-popup {
		.image {
			width: 100px;
			height: 100px;
			background: var(--img);
			border-radius: 8px;
			background-size: cover;
			background-position: center;
		}
	}
</style>
